import { render, staticRenderFns } from "./SwifterUpload.vue?vue&type=template&id=12114a6c&scoped=true"
import script from "./SwifterUpload.vue?vue&type=script&lang=js"
export * from "./SwifterUpload.vue?vue&type=script&lang=js"
import style0 from "./SwifterUpload.vue?vue&type=style&index=0&id=12114a6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12114a6c",
  null
  
)

export default component.exports